import React, { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, formatDate } from "../../lib/apiClient";
import { Switch } from "../ui/switch";

const RUN_LABEL = { enviado: "Correo enviado", sin_novedades: "Sin novedades", consulta_fallida: "Consulta fallida" };

export function ComparableAlertsCard({ caseId, isOwner }) {
  const [alert, setAlert] = useState(null);
  const [freq, setFreq] = useState("weekly");
  const [busy, setBusy] = useState(false);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    api.get(`/cases/${caseId}/comparable-alerts`).then(({ data }) => {
      setAlert(data.alert);
      setPaused(!!data.paused_by_admin);
      if (data.alert?.frequency) setFreq(data.alert.frequency);
    }).catch(() => {});
  }, [caseId]);

  const save = async (enabled, frequency) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/cases/${caseId}/comparable-alerts`, { enabled, frequency });
      setAlert(data.alert);
      toast.success(enabled ? "Alertas activadas" : "Alertas desactivadas");
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "No se pudo guardar");
    } finally {
      setBusy(false);
    }
  };

  if (!isOwner) return null;
  const on = !!alert?.enabled;
  return (
    <section className="mt-6 border border-gray-200 bg-white p-6" data-testid="comparable-alerts-card">
      <div className="flex items-start justify-between gap-4">
        <div className="flex gap-3">
          <BellRing className="w-5 h-5 text-primary mt-0.5" />
          <div>
            <p className="text-sm font-medium text-gray-900">Alertas de nuevos contratos SECOP</p>
            <p className="text-xs text-gray-600 mt-0.5">
              Te escribimos solo cuando aparezcan contratos nuevos parecidos a tu caso en {alert?.department || "su departamento"}.
            </p>
          </div>
        </div>
        <Switch checked={on} disabled={busy} onCheckedChange={(v) => save(v, freq)} data-testid="comparable-alerts-toggle" />
      </div>
      {paused && (
        <p className="mt-3 pl-8 text-xs text-amber-800" data-testid="comparable-alerts-paused">
          El envío de estas alertas está pausado temporalmente por el equipo de JustSapiens. Su preferencia se conserva.
        </p>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-3 pl-8">
        <span className="text-xs text-gray-500">Frecuencia</span>
        {[["daily", "Diario"], ["weekly", "Semanal"]].map(([k, lbl]) => (
          <button
            key={k}
            type="button"
            disabled={busy}
            onClick={() => { setFreq(k); if (on) save(true, k); }}
            className={`text-xs px-3 py-1 border rounded-full transition-colors ${freq === k ? "bg-primary text-white border-primary" : "border-gray-300 text-gray-700 hover:border-primary"}`}
            data-testid={`comparable-alerts-freq-${k}`}
          >
            {lbl}
          </button>
        ))}
      </div>
      {on && (
        <p className="text-[11px] text-gray-500 mt-3 pl-8" data-testid="comparable-alerts-status">
          Activas · próxima revisión {formatDate(alert.next_due_at)}
          {alert.last_sent_at && <> · último correo {formatDate(alert.last_sent_at)}</>}
          {alert.recent_runs?.[0] && <> · última corrida: {RUN_LABEL[alert.recent_runs[0].status] || alert.recent_runs[0].status}</>}
        </p>
      )}
    </section>
  );
}
